import type { SVGProps } from 'react';

const LockDocumentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.423529"
      y="0.423529"
      width="63.1529"
      height="63.1529"
      rx="31.5765"
      fill="#FFF4E8"
    />
    <rect
      x="0.423529"
      y="0.423529"
      width="63.1529"
      height="63.1529"
      rx="31.5765"
      stroke="#FB9318"
      strokeWidth="0.847059"
    />
    <path
      d="M34.8307 17.834H27.4641C25.0838 17.834 23.8937 17.834 22.9846 18.2972C22.1849 18.7047 21.5347 19.3548 21.1273 20.1545C20.6641 21.0636 20.6641 22.2538 20.6641 24.634V39.3673C20.6641 41.7475 20.6641 42.9377 21.1273 43.8468C21.5347 44.6465 22.1849 45.2966 22.9846 45.7041C23.8937 46.1673 25.0838 46.1673 27.4641 46.1673H36.5307C38.911 46.1673 40.1011 46.1673 41.0102 45.7041C41.8099 45.2966 42.46 44.6465 42.8675 43.8468C43.3307 42.9377 43.3307 41.7475 43.3307 39.3673V26.334M34.8307 17.834L43.3307 26.334M34.8307 17.834V26.334H43.3307M34.4766 34.834V32.3548C34.4766 30.9856 33.3666 29.8757 31.9974 29.8757C30.6282 29.8757 29.5182 30.9856 29.5182 32.3548V34.834M29.3057 40.5007H34.6891C35.4825 40.5007 35.8792 40.5007 36.1822 40.3462C36.4488 40.2104 36.6655 39.9937 36.8013 39.7271C36.9557 39.4241 36.9557 39.0274 36.9557 38.234V37.1007C36.9557 36.3072 36.9557 35.9105 36.8013 35.6075C36.6655 35.3409 36.4488 35.1242 36.1822 34.9884C35.8792 34.834 35.4825 34.834 34.6891 34.834H29.3057C28.5123 34.834 28.1156 34.834 27.8126 34.9884C27.546 35.1242 27.3293 35.3409 27.1935 35.6075C27.0391 35.9105 27.0391 36.3072 27.0391 37.1007V38.234C27.0391 39.0274 27.0391 39.4241 27.1935 39.7271C27.3293 39.9937 27.546 40.2104 27.8126 40.3462C28.1156 40.5007 28.5123 40.5007 29.3057 40.5007Z"
      stroke="#FB9318"
      strokeWidth="1.69412"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LockDocumentIcon;
